
export interface Flashcard {
  term: string;
  definition: string;
  icon_suggestion: string;
}

export interface ExplanationResponse {
  parent_explanation: string;
  child_explanation: string;
  steps: string[];
  questions_for_child: string[];
  teaching_tips: string[];
  concrete_examples: string[];
  flashcards: Flashcard[];
  confidence_score: number;
}

/**
 * Calls our local /api/explain backend which handles the Gemini API key securely.
 */
export const getAdvancedExplanation = async (
  topicOrText: string,
  ageRange: string,
  imageContent?: { data: string; mimeType: string },
  isRefining: boolean = false
): Promise<ExplanationResponse> => {
  try {
    const response = await fetch('/api/explain', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        topicOrText,
        ageRange,
        imageContent,
        isRefining
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to get explanation from server.");
    }

    return await response.json();
  } catch (error: any) {
    console.error("Service Error:", error);
    throw new Error(error.message || "I couldn't process this homework right now. Please try again later.");
  }
};
